<template>
  <div class="container-xl">
  <metainfo></metainfo>
  <template v-if="isForbiddenPage()">
    <NoPermission />
  </template>
  <template v-else>
    <div class="page-header d-print-none">
      <Alert :payload="{
          new_cnt: counted.newCnt,
          delete_cnt: counted.deleteCnt,
      }"/>
      <div class="row g-2 align-items-center">
        <div class="col-sm">
          <Title :payload="{
            title: 'Промокоды',
            page_root: true,
          }"/>
        </div>
        <div class="col-auto">
          <button class="btn btn-yellow me-2" @click="goCanceled">
            Отмененные
          </button>
          <button class="btn btn-primary" @click="goLinked">
            Связи с магазинами
          </button>
        </div>
      </div>
    </div>
    <div class="page-body">
      <div class="mb-3">
        <ShopFilter @onFilter="onFilter" :params="getParams()" />
      </div>
      <div ref="scrollComponent">
        <ShopList :query="getQuery()" @onRender="onRender" :clear-result="getClearResult()" />
      </div>
    </div>
  </template>
  </div>
</template>

<script>
import {defineComponent, onMounted, onUnmounted, reactive, ref} from 'vue'
import {useMeta} from "vue-meta"
import Helper from "@/services/Helper"
import Permission from "@/modules/users/services/Permission"
import NoPermission from "@/modules/auth/pages/no_permission/Index"
import {useRouter} from "vue-router/dist/vue-router"
import ShopFilter from "@/modules/promocodes/pages/shops/components/filter/Index"
import ShopList from "@/modules/promocodes/pages/shops/components/list/Index"
import Api from "@/modules/promocodes/pages/shops/services/Api"
import Alert from "../../components/alert/Index"
import Title from "../../components/title/Index"

export default defineComponent({
  name: "ListShop",
  components: {
    NoPermission,
    ShopFilter,
    ShopList,
    Alert,
    Title,
  },
  setup() {
    const router = useRouter()

    useMeta({title: "Промокоды"})

    let counted = reactive({
      newCnt: 0,
      deleteCnt: 0,
    })

    const scrollComponent = ref(null)

    let query = ref({})
    let clearResult = ref(false)
    let offset = ref(0)
    let eofResult = ref(false)
    let countPosts = ref(0)
    let isLoading = ref(false)
    let noPermission = ref(false)
    let scroll = () => {
      isLoading.value = true
      offset.value += 18

      onLoadMore(offset.value)
    }
    let params = {
      search: "",
      enable: true,
      is_linked: true,
    }

    function onRender(payload) {
      eofResult.value = payload["oef_items"] === true
      if (payload["count_items"] > 0) {
        countPosts.value = payload["count_items"];
      }
      clearResult.value = false
      isLoading.value = false
    }

    function onFilter(q) {
      clearResult.value = true
      offset.value = 0
      eofResult.value = false
      countPosts.value = 0

      q = Helper.mergeObject(q, {
        "limit": 18,
        "offset": offset.value,
      })

      q = Helper.clone(q)

      query.value = q
    }

    function onLoadMore(offset) {
      if (Helper.isEmptyObject(query.value)) {
        return false
      }

      let q = Helper.clone(query.value)

      query.value = Helper.mergeObject(q, {
        "offset": offset,
      })
    }

    const handleScroll = () => {
      if (eofResult.value) return

      let element = scrollComponent.value

      if (!isLoading.value && element.getBoundingClientRect().bottom < window.innerHeight) {
        scroll()
      }
    }

    onMounted(() => {
      if (!checkPermission()) {
        return
      }

      loadCounted()

      window.addEventListener("scroll", handleScroll)
    })

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll)
    })

    function checkPermission() {
    // Раскомментить при добавлении реальных доступов
    // if (!Permission.hasPermissions("admin_promocodes")) {
    // Удалить при добавлении реальных доступов
      if (Permission.hasPermissions("admin_promocodes")) {
        setNoPermission()
        return false
      }

      return true
    }

    function setNoPermission() {
      noPermission.value = true
    }

    function isForbiddenPage() {
      return noPermission.value
    }

    function getParams() {
      return params
    }

    function getQuery() {
      return query.value
    }

    function getClearResult() {
      return clearResult.value
    }

    function loadCounted() {
      Api.statistic().then((resp) => {
        let data = resp.data.data

        counted.newCnt = data["coupon_not_parsed"]
        counted.deleteCnt = data["coupon_delst"]
      })
    }

    function goLinked() {
      let routeData = router.resolve({
        name: 'PromocodesListShopLinks',
      })

      window.open(routeData.href, '_self')
    }

    function goCanceled() {
      let routeData = router.resolve({
        name: 'PromocodesListCouponCancel',
      })

      window.open(routeData.href, '_self')
    }

    return {
      counted,
      getParams,
      getQuery,
      getClearResult,
      onRender,
      onFilter,
      scrollComponent,
      isForbiddenPage,
      goLinked,
      goCanceled,
    }
  }
})
</script>
